import { render, staticRenderFns } from "./InsPhotoGallery.vue?vue&type=template&id=36975e70&scoped=true"
import script from "./InsPhotoGallery.vue?vue&type=script&lang=ts"
export * from "./InsPhotoGallery.vue?vue&type=script&lang=ts"
import style0 from "./InsPhotoGallery.vue?vue&type=style&index=0&id=36975e70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36975e70",
  null
  
)

export default component.exports